import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Loader } from './components';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.scss';
import './i18n';
ReactDOM.createRoot(document.getElementById('root')).render(_jsx(React.Suspense, Object.assign({ fallback: _jsx("div", Object.assign({ className: "h-100 d-flex justify-content-center align-items-center" }, { children: _jsx(Loader, { type: "text-primary" }) })) }, { children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) })));
